<input #imageUpload
       (change)="onFileSelected($event.target)"
       [style.display]="'none'" accept=".doc,.docx,.pdf,.jpg,.jpeg,.png" class="file-input"
       type="file"/>
<button
  (click)="imageUpload.click()" [color]="color" mat-raised-button>
  <mat-icon fontIcon="attachment"></mat-icon>
  {{ text }}
</button>